<input v-model="dataValue" v-bind="attrs" @focus="focusHandler" @blur="blurHandler" @input="setData" @keypress="isNumber($event)">